import * as React from "react";
import { forwardRef } from "react";
const SvgDot = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", fill: "current", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("circle", { cx: 20, cy: 20, r: 20 }));
const ForwardRef = forwardRef(SvgDot);
export { ForwardRef as ReactComponent };
